import Router from "@/helpers/router";

import {
  WHATS_NEW_AUDIENCES,
  WHATS_NEW_ICONS,
  WhatsNewEntryI,
} from "../lib/types";

const { ADMIN } = WHATS_NEW_AUDIENCES;

/**
 * Admin → Rep workspaces and Activity on the Admin page (C-16 S5,
 * GLE-8416). Admins only. The tab needs Team → Reps (`features.reps`), so
 * the entry waits for it too; a window from the release to release + 14
 * days, and each Admin sees it on two ET days (C16-D425, C16-D455).
 */
export const ADMIN_REP_WORKSPACES_2026_10_27: WhatsNewEntryI = {
  id: "2026-10-27-admin-rep-workspaces",
  feature: "reps",
  startsAt: "2026-10-27T04:00:00.000Z",
  endsAt: "2026-11-10T05:00:00.000Z",
  title: {
    [ADMIN]: "Assign reps to workspaces from Admin",
  },
  intro: {
    [ADMIN]:
      "Reps who were accepted without a workspace can now be assigned from the Admin page, and Activity lives there too.",
  },
  sections: [
    {
      id: "rep-workspaces",
      audiences: [ADMIN],
      icon: WHATS_NEW_ICONS.TEAM,
      title: "Admin → Rep workspaces",
      items: [
        "Every rep in one list, the ones with no workspace first.",
        "Assign a rep to a workspace, or move a rep to another one. Before you confirm, the dialog says what changes.",
        "Narrow it to Unassigned or to one workspace, or search by name or email.",
        "Deactivate or reactivate a rep on their workspace from the ⋯ menu.",
      ],
      link: {
        label: "Open Rep workspaces",
        href: Router.manageAdmin("rep-workspaces"),
      },
    },
    {
      id: "activity",
      audiences: [ADMIN],
      icon: WHATS_NEW_ICONS.SHIELD,
      title: "Activity moved to Admin",
      items: [
        "Team → Activity is now a tab on the Admin page. Old links still work.",
      ],
      link: { label: "Open Activity", href: Router.manageAdmin("activity") },
    },
  ],
};
